<section class="cuenta">
	<h1>Mi cuenta</h1>
	<section>
		<div class="cuenta-menu">
			<section (click)="fnCambiarState( newItem )" [ngClass]="{ 'activate': (newItem.id === newState.id) }" class="activate" *ngFor="let newItem of listaStates">
				<p>{{ newItem.titulo }}</p>
			</section>
		</div>
		<div class="cuenta-content">
			<section>
				<p>
					<span [innerHTML]=" newState.icono "></span> {{ newState.titulo }} 
					<span class="iconEditar" *ngIf=" !editarDatos && newState.id === 1 " (click)=" fnInitEdicion( true ) ">
						<i class="far fa-edit"></i>
					</span>
					<span class="iconEditar" *ngIf=" !registrarDireccion && newState.id === 2 " (click)=" fnInitDireccion() ">
						<small>Agregar dirección &ensp;</small> <i class="far fa-plus-square"></i>
					</span>
				</p>
			</section>
			<div *ngIf=" newState.id === 1 ">
				<div class="multiple">
					<div class="control col4">
						<h2 class="color-black-bold">Puntos</h2>
						<h3>{{ currentCliente.puntos }}</h3>
					</div>
					<div class="control col4">
						<h2 class="color-black-bold">Saldo</h2>
						<h3>{{ currentCliente.saldo | currency:currentCliente.divisa:'symbol':'.2-2' }}</h3>
					</div>
					<div class="control col4 " *ngIf=" currentCliente.cupon ">
						<h2 class="color-black-bold">Cupón</h2>
						<h3>{{ currentCliente.cupon }}</h3>
					</div>
				</div>
				<div class="multiple">
					<div class="control col4">
						<h2 class="color-black-bold">Nombre (s)</h2>
						<h3 *ngIf=" !editarDatos ">{{ currentCliente.nombre }}</h3>
						<input *ngIf=" editarDatos " type="text" placeholder="Nombre (s)" [(ngModel)]="newCliente.nombre">
					</div>
					<div class="control col4">
						<h2 class="color-black-bold">Apellido paterno</h2>
						<h3 *ngIf=" !editarDatos ">{{ currentCliente.paterno }}</h3>
						<input *ngIf=" editarDatos " type="text" placeholder="Apellido paterno" [(ngModel)]="newCliente.paterno">
					</div>
					<div class="control col4">
						<h2 class="color-black-bold">Apellido materno</h2>
						<h3 *ngIf=" !editarDatos ">{{ currentCliente.materno }}</h3>
						<input *ngIf=" editarDatos " type="text" placeholder="Apellido materno" [(ngModel)]="newCliente.materno">
					</div>
				</div>
				<div class="multiple">
					<div class="control col4">
						<h2 class="color-black-bold">Teléfono</h2>
						<h3 *ngIf=" !editarDatos ">{{ currentCliente.telefono }}</h3>
						<div *ngIf=" editarDatos ">
							<input type="text" class="telInput" 
							ng2TelInput
							[ng2TelInputOptions]="{initialCountry: 'in'}"
							(hasError)="hasError($event)"
							(ng2TelOutput)="getNumber($event)"
							(intlTelInputObject)="telInputObject($event)"
							(countryChange)="onCountryChange($event)" />
						</div>
					</div>
					<div class="control col4">
						<h2 class="color-black-bold">Correo electrónico</h2>
						<h3>{{ currentCliente.correo }}</h3>
					</div>
				</div>
				<div class="multiple reverse" *ngIf=" editarDatos ">
					<div class="control-btn col3 offset6">
						<button class="fondo-blue" (click)="fnActualizarDatosPersonales()">Guardar</button>
					</div>
					<div class="control-btn col3">
						<button class="fondo-purple" (click)=" fnInitEdicion( false ) ">Cancelar</button>
					</div>
				</div>
				<br>
				<br>
				<h3 class="seguridad" (click)=" showSecurity = !showSecurity ">
					<p>
						<i class="fas fa-shield-alt"></i>
						Cambiar contraseña de tu cuenta
						<span *ngIf=" showSecurity ">
							<i class="fas fa-angle-up"></i>
						</span>
						<span *ngIf=" !showSecurity ">
							<i class="fas fa-angle-down"></i>
						</span>
					</p>
					<hr>
				</h3>
				<br>
				<div class="multiple" *ngIf=" showSecurity ">
					<div class="control col4">
						<label>Contraseña</label>
						<div class="multiple flex">
							<input class="col10" type="{{ (showClave)?'text':'password' }}" placeholder="Contraseña" [(ngModel)]="newSeguridad.password">
							<button class="col2 fondo-green" (click)=" showClave = !showClave ">
								<span *ngIf=" showClave "><i class="far fa-eye"></i></span>
								<span *ngIf=" !showClave "><i class="far fa-eye-slash"></i></span>
							</button>
						</div>
					</div>
					<div class="control col4">
						<label>Confirmar contraseña</label>
						<div class="multiple flex">
							<input class="col10" type="{{ (showConfirm)?'text':'password' }}" placeholder="Contraseña" [(ngModel)]="newSeguridad.confirmacion">
							<button class="col2 fondo-green" (click)=" showConfirm = !showConfirm ">
								<span *ngIf=" showConfirm "><i class="far fa-eye"></i></span>
								<span *ngIf=" !showConfirm "><i class="far fa-eye-slash"></i></span>
							</button>
						</div>
					</div>
					<div class="control-btn col4">
						<label class="color-white movile-hidden">&</label>
						<button class="fondo-blue" (click)="fnActualizarClave()">Guardar</button>
					</div>
				</div>
			</div>
			<div *ngIf=" newState.id === 2 ">
				
				<section class="direccion-content" *ngIf=" !registrarDireccion ">
					<div class="direccion-content-item" *ngFor="let newItem of listaDirecciones">
						<div class="direccion-content-option">
							<span>
								<span class="fa-stack" (click)="fnSeleccionDireccion( newItem )">
									<i class="far fa-circle fa-stack-2x"></i>
									<i class="far fa-edit fa-stack-1x"></i>
								</span>
							</span>
							<span>
								<span class="fa-stack" (click)="fnEliminarDireccionEnvio( newItem )">
									<i class="far fa-circle fa-stack-2x"></i>
									<i class="far fa-trash-alt fa-stack-1x"></i>
								</span>
							</span>
						</div>
						<h3 [innerHtml]="newItem.nombre"></h3>
					</div>
				</section>

				<section *ngIf=" registrarDireccion ">
					<div class="multiple">
						<div class="control col6">
							<label>Calle</label>
							<input type="text" placeholder="Calle" [(ngModel)]="newDireccion.calle">
						</div>
						<div class="control col3">
							<label>Número exterior</label>
							<input type="text" placeholder="Número exterior" [(ngModel)]="newDireccion.exterior">
						</div>
						<div class="control col3">
							<label>Número interior</label>
							<input type="text" placeholder="Número interior" [(ngModel)]="newDireccion.interior">
						</div>
					</div>
					<div class="multiple">
						<div class="control col3">
							<label>Código postal</label>
							<input type="text" placeholder="Código postal" [(ngModel)]="newDireccion.codigoPostal" (blur)="fnCargarColonias()">
						</div>
						<div class="control col9">
							<label>Colonia</label>
							<app-select iniciar=true (newModelo)="fnSeleccionColonia( $event )" [titulo]="'Colonia'" [currentModelo]="newDireccion.colonia" [listaElementos]="listaColonias"></app-select>
						</div>
					</div>
					<div class="multiple">
						<div class="control col4">
							<label>Municipio</label>
							<input type="text" placeholder="Municipio" [(ngModel)]="newDireccion.municipio">
						</div>
						<div class="control col4">
							<label>Estado</label>
							<input type="text" placeholder="Estado" [(ngModel)]="newDireccion.estado">
						</div>
						<div class="control col4">
							<label>País</label>
							<input type="text" placeholder="País" [(ngModel)]="newDireccion.pais">
						</div>
					</div>
					<div class="multiple">
						<div class="control col12">
							<label>Referencia</label>
							<input type="text" placeholder="Referencia" [(ngModel)]="newDireccion.referencia">
						</div>
					</div>
					<div class="multiple reverse">
						<div class="control-btn col3 offset6">
							<button class="fondo-blue" (click)="fnActualizarDireccionEnvio()">Guardar</button>
						</div>
						<div class="control-btn col3">
							<button class="fondo-purple" (click)=" fnCancelarDireccion() ">Cancelar</button>
						</div>
					</div>
				</section>

			</div>
			<div *ngIf=" newState.id === 3 ">
				<div class="pedidos-content">
					<section class="pedido-menu">
						<div [ngClass]="{ 'active': newItem.active }" *ngFor="let newItem of menuPedidos" (click)="fnCambiarPedidos( newItem )">
							<h3> 
								<span [innerHTML]="newItem.icono | safe:'html'"></span>
								{{ newItem.nombre }}
							</h3>
						</div>
					</section>
					<section class="productos-paginador" *ngIf=" listaPedidos.length === 0 ">
						<br>
						<h1> <p class="color-purple">{{ leyenda }}</p> </h1>
					</section>
					<section class="pedido-item-content">
						<section *ngFor="let newItem of listaPedidos" (click)="fnMostrarDetallePedido( newItem )" [ngClass]="fnClassPedido( newItem )">
							<div class="multiple">
								<div class="control col4">
									<h2>Folio:</h2> <h4>{{ newItem.folio }}</h4>
								</div>
								<div class="control col4">
									<h2>Fecha de compra:</h2> <h4>{{ newItem.fecha }}</h4>
								</div>
								<div class="control col4">
									<h2>Estatus de envío:</h2> <h4 class="estatus">{{ newItem.estatusEnvio }}</h4>
								</div>
							</div>
							<div class="multiple">
								<div class="control col12">
									<h2>Dirección de envío:</h2> <h4>{{ newItem.direccion }}</h4>
								</div>
							</div>
						</section>
					</section>
				</div>
				<section class="productos-paginador">
					<div>
						<div>
							<p>Mostrando {{ paginacion.inicio }} - {{ paginacion.fin }} de {{ totalProductos }} resultados</p>
						</div>
						<div>
							<app-paginador (eventSuccess)="fnPaginarProductos( $event )" (eventFail)="fnErrorPaginador( $event )" [totalPaginas]="paginacion.totalPaginas"></app-paginador>
						</div>
					</div>
				</section>
			</div>
			<div *ngIf=" newState.id === 4 ">
				<section class="productos-paginador" *ngIf=" listaFavoritos.length === 0 ">
					<h1>Aun no tienes productos en tu Wishlist, <a class="color-purple" [routerLink]="['/tienda']">ve nuestros productos</a></h1>
				</section>
				<app-item-wish-list [newInventarioDetalle]="newItem" *ngFor="let newItem of listaFavoritos"></app-item-wish-list>
				<section class="productos-paginador" *ngIf=" listaFavoritos.length > 0 ">
					<div>
						<div>
							<p>Mostrando {{ paginacion.inicio }} - {{ paginacion.fin }} de {{ totalProductos }} resultados</p>
						</div>
						<div>
							<app-paginador (eventSuccess)="fnPaginarProductos( $event )" (eventFail)="fnErrorPaginador( $event )" [totalPaginas]="paginacion.totalPaginas"></app-paginador>
						</div>
					</div>
				</section>
			</div>
		</div>
	</section>
</section>